import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    automanaged: true,
    authenticated: false,
    showBack: false,
    showNavbar: true,
    pageBack: '',
    redirectPage: 'Login',
    title: 'イタリア料理リベルタ',
    userinfo: {},
    stampid: '',
    confirmdef: {},
    baseurl: 'https://cloud.salesmini.cn'
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
